import {observer} from "mobx-react";
import {GlobalState} from "../../state/GlobalState";

const BrowserTitle = observer(() => {
    document.title = GlobalState.pageTitle;

    return <></>
});

export default BrowserTitle;